import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  type ContactLogEntry,
  type LogContactParams,
} from "../../../domain/entities/pending-confirmation";
import { type PendingConfirmationDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const logContact = createAsyncThunk<
  ContactLogEntry,
  LogContactParams,
  { dispatch: PendingConfirmationDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.LOG_CONTACT, async (params, { extra }) => {
  return await extra.contactCenterRepo.logContact(params);
});
